import { useState } from 'react';

/**
 * Bundles the "click delete → confirm in a modal → run the action" state machine that recurs
 * anywhere a row-level action needs a confirmation step. `target` doubles as the open/closed
 * flag — there is no separate boolean to fall out of sync with it.
 */
export function useConfirmAction<T>(action: (target: T) => void) {
    const [target, setTarget] = useState<T | null>(null);

    const request = (value: T) => setTarget(value);

    const confirm = () => {
        if (target !== null) action(target);
        setTarget(null);
    };

    const cancel = () => setTarget(null);

    return { target, isOpen: target !== null, request, confirm, cancel };
}
